export default class StandardSheetAnimations {
	static getAnimation(sheet) {
		let animation = JSON.parse(JSON.stringify(StandardSheetAnimations.animation));
		for (let x = 0; x < animation.length; x++) {
			if (animation[x].sheet === "standard") {
				animation[x].sheet = sheet;
			}
		}
		return animation;
	}

}
StandardSheetAnimations.animation = [
	{
		id: "idle_s",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: 640
			},
			{
				row: 0,
				col: 1,
				time: 80
			},
			{
				row: 0,
				col: 2,
				time: 640
			},
			{
				row: 0,
				col: 1,
				time: 80
			}
		]
	},
	{
		id: "idle_n",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 10,
				col: 3,
				time: 800
			},
			{
				row: 4,
				col: 3,
				time: 800
			}
		]
	},
	{
		id: "idle_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 9,
				col: 3,
				time: 800
			},
			{
				row: 3,
				col: 3,
				time: 800
			}
		]
	},
	{
		id: "idle_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 9,
				col: 3,
				time: 800
			},
			{
				row: 3,
				col: 3,
				time: 800
			}
		]
	},
	{
		id: "walk_s",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 2,
				col: 0,
				time: 100
			},
			{
				row: 2,
				col: 1,
				time: 100
			},
			{
				row: 2,
				col: 2,
				time: 100
			},
			{
				row: 2,
				col: 3,
				time: 100
			}
		]
	},
	{
		id: "walk_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 3,
				col: 0,
				time: 100
			},
			{
				row: 3,
				col: 1,
				time: 100
			},
			{
				row: 3,
				col: 2,
				time: 100
			},
			{
				row: 3,
				col: 3,
				time: 100
			}
		]
	},
	{
		id: "walk_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 3,
				col: 0,
				time: 100
			},
			{
				row: 3,
				col: 1,
				time: 100
			},
			{
				row: 3,
				col: 2,
				time: 100
			},
			{
				row: 3,
				col: 3,
				time: 100
			}
		]
	},
	{
		id: "walk_n",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 4,
				col: 0,
				time: 100
			},
			{
				row: 4,
				col: 1,
				time: 100
			},
			{
				row: 4,
				col: 2,
				time: 100
			},
			{
				row: 4,
				col: 3,
				time: 100
			}
		]
	},
	{
		id: "attack_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 6,
				col: 0,
				time: 300
			},
			{
				row: 6,
				col: 1,
				time: 100
			},
			{
				row: 6,
				col: 2,
				time: 100
			},
			{
				row: 6,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "attack_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 6,
				col: 0,
				time: 300
			},
			{
				row: 6,
				col: 1,
				time: 100
			},
			{
				row: 6,
				col: 2,
				time: 100
			},
			{
				row: 6,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "hit_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 9,
				col: 0,
				time: 300
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 200
			},
			{
				row: 9,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "hit_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 9,
				col: 0,
				time: 300
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 200
			},
			{
				row: 9,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "hit_n",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 10,
				col: 0,
				time: 300
			},
			{
				row: 11,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 0,
				time: -1
			}
		]
	},

	{
		id: "hit_s",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 8,
				col: 0,
				time: 300
			},
			{
				row: 11,
				col: 0,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 1,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "parry_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 3,
				col: 3,
				time: 300
			},
			{
				row: 6,
				col: 3,
				time: 300
			},
			{
				row: 6,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "parry_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 3,
				col: 3,
				time: 300
			},
			{
				row: 6,
				col: 3,
				time: 300
			},
			{
				row: 6,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "dead_e",
		sheet: "dead",
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: 100
			},
			{
				row: 0,
				col: 1,
				time: 100
			},
			{
				row: 0,
				col: 2,
				time: 100
			},
			{
				row: 0,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "dead_w",
		sheet: "dead",
		flip: true,
		frames: [
			{
				row: 0,
				col: 0,
				time: 100
			},
			{
				row: 0,
				col: 1,
				time: 100
			},
			{
				row: 0,
				col: 2,
				time: 100
			},
			{
				row: 0,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "won_s",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 1,
				col: 0,
				time: 640
			},
			{
				row: 1,
				col: 1,
				time: 80
			},
			{
				row: 1,
				col: 2,
				time: -1
			}
		]
	},
	{
		id: "miss_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 9,
				col: 3,
				time: 800
			},
			{
				row: 3,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "miss_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 9,
				col: 3,
				time: 800
			},
			{
				row: 3,
				col: 3,
				time: -1
			}
		]
	},
	{
		id: "hitmaze_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 9,
				col: 0,
				time: 40
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 500
			},
			{
				row: 9,
				col: 0,
				time: 100
			},
			{
				goto: "idle_e"
			}
		]
	},
	{
		id: "hitmaze_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 9,
				col: 0,
				time: 40
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 500
			},
			{
				row: 9,
				col: 0,
				time: 100
			},
			{
				goto: "idle_w"
			}
		]
	},


	{
		id: "hitmaze_n",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 10,
				col: 0,
				time: 40
			},
			{
				row: 11,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 0,
				time: 500
			},
			{
				row: 10,
				col: 0,
				time: 100
			},
			{
				goto: "idle_n"
			}
		]
	},

	{
		id: "hitmaze_s",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 8,
				col: 0,
				time: 40
			},
			{
				row: 11,
				col: 0,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 1,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 0,
				time: 500
			},
			{
				row: 8,
				col: 0,
				time: 100
			},
			{
				goto: "idle_s"
			}
		]
	},



	{
		id: "hitmazedeath_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 9,
				col: 0,
				time: 40
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 100
			},
			{
				goto: "dead_e"
			}
		]
	},
	{
		id: "hitmazedeath_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 9,
				col: 0,
				time: 40
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 100
			},
			{
				goto: "dead_e"
			}
		]
	},


	{
		id: "hitmazedeath_n",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 10,
				col: 0,
				time: 40
			},
			{
				row: 11,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 0,
				time: 100
			},
			{
				goto: "dead_e"
			}
		]
	},

	{
		id: "hitmazedeath_s",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 8,
				col: 0,
				time: 40
			},
			{
				row: 11,
				col: 0,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 1,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 0,
				time: 100
			},
			{
				goto: "dead_e"
			}
		]
	},


	{
		id: "hitmazeenemy_e",
		sheet: "standard",
		flip: false,
		frames: [
			{
				row: 9,
				col: 0,
				time: 40
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "hitmazeenemy_w",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 9,
				col: 0,
				time: 40
			},
			{
				row: 0,
				col: 3,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 1,
				time: 80
			},
			{
				row: 9,
				col: 2,
				time: 80
			},
			{
				row: 9,
				col: 0,
				time: 500
			},
			{
				row: 9,
				col: 0,
				time: -1
			}
		]
	},


	{
		id: "hitmazeenemy_n",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 10,
				col: 0,
				time: 40
			},
			{
				row: 11,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 1,
				time: 80
			},
			{
				row: 10,
				col: 2,
				time: 80
			},
			{
				row: 10,
				col: 0,
				time: 500
			},
			{
				row: 10,
				col: 0,
				time: -1
			}
		]
	},

	{
		id: "hitmazeenemy_s",
		sheet: "standard",
		flip: true,
		frames: [
			{
				row: 8,
				col: 0,
				time: 40
			},
			{
				row: 11,
				col: 0,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 1,
				time: 80
			},
			{
				row: 8,
				col: 2,
				time: 80
			},
			{
				row: 8,
				col: 0,
				time: 500
			},
			{
				row: 8,
				col: 0,
				time: -1
			}
		]
	},



];
